module.exports = __webpack_public_path__ + "img/tshirt-cmc.a67d828b.svg";